import { add as mathAdd, subtract, multiply, divide } from "mathjs";

export function add(a, b) {
  return parseFloat(mathAdd(a, b));
}

export function sub(a, b) {
  return parseFloat(subtract(a, b));
}

export function mul(a, b) {
  return parseFloat(multiply(a, b));
}

export function div(a, b) {
  return parseFloat(divide(a, b));
}

export function addFixed(a, b, places = 2) {
  return parseFloat(mathAdd(a, b).toFixed(places));
}

export function subFixed(a, b, places = 2) {
  return parseFloat(subtract(a, b).toFixed(places));
}

export function mulFixed(a, b, places = 2) {
  return parseFloat(multiply(a, b).toFixed(places));
}

export function divFixed(a, b, places = 2) {
  return parseFloat(divide(a, b).toFixed(places));
}
